import React from "react";
import { Button, Label, Modal, ModalBody } from "reactstrap";

const QrCodeInstructionModal = ({ isOpen, toggle }) => {
  return (
    <Modal centered isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <Label>
          <h3 className="custom-label text-dark">
            <span className="text-underline">Instructions for Athlete</span> :
            How to put your QR on your own badges at FHP:
          </h3>
        </Label>
        <Label className="custom-checkbox-label text-dark">
          <ul>
            <li>Make your video, see script on your Chat Home Page.</li>
            <li>Load your video on YouTube.</li>
            <li>Get URL from YouTube.</li>
            <li>
              Use the URL to generate a QR (at QRcodechimp.com or
              AdobeExpressQR).
            </li>
            <li>Upload the QR to your profile.</li>
            <li>Now FHP will put that QR on your subscription badges.</li>
            <li>
              This way your fans can buy your badge, scan the QR, see your
              video.
            </li>
          </ul>
        </Label>
        <div className="text-right">
          <Button
            color="danger"
            onClick={toggle}
          >
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default QrCodeInstructionModal;
